import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface AddTaxRateRequest {
  name: string;
  id: number;
  tax: number;
}

export type AddTaxRateResponse = BaseResponse<null>;

async function addTaxRate(
  data: AddTaxRateRequest
): Promise<AddTaxRateResponse> {
  try {
    return (await axiosInstance.post("/Product/AddTaxRate", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddTaxRate() {
  return useMutation<AddTaxRateResponse, Error, AddTaxRateRequest>(
    (variables) => addTaxRate(variables)
  );
}
